
const digest = 'b32800b3320bde8d2c8d2f08f7d7a2ce60182f85e63c5f980b473708fb26e45c';
const classes = {"button":"_button_dp4qs_1","note":"_note_dp4qs_5"};
const css = `._button_dp4qs_1 {
  font-size: 12px;
}

._note_dp4qs_5 {
  font-family: Rubik, "sans-serif";
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  